export default "__VITE_ASSET__a8d623cd__"